<div class="footer-page">
  <section class="page-shell footer-page-shell is-tight">
    <div class="custom-container">
      <footer class="footer-area">
        <div class="content-shell footer-shell">
          <div class="footer-main">
            <div class="row g-4">
              <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                  <h3 class="footer-widget-title">Contact Us</h3>

                  <ul class="contact-us-link">
                    <li>
                      <i class="bx bx-map"></i>
                      <a href="#" target="_blank">
                        Madurai Sivagangai Main Road,
                        <br />Madurai - 625 020.
                        <br />Tamil Nadu.
                        <br />India
                      </a>
                    </li>

                    <li>
                      <i class="bx bx-phone-call"></i>
                      <a href="tel:+919942982322">+91 99429 82322</a><br />
                      <a href="tel:+919942982321">+91 99429 82321</a><br />
                      <a href="tel:+919942982311">+91 99429 82311</a>
                    </li>

                    <li>
                      <i class="bx bx-envelope"></i>
                      <a href="mailto:principal@fmcet.ac.in">principal&#64;fmcet.ac.in</a><br /><br />
                      <a href="mailto:mr@fmcet.ac.in">mr&#64;fmcet.ac.in</a>
                    </li>
                  </ul>

                  <ul class="social-link">
                    <li>
                      <a
                        href="https://www.facebook.com/FatimaMichaelEngineeringCollegeMadurai"
                        class="d-block"
                        target="_blank"
                      >
                        <i class="bx bxl-facebook"></i>
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://www.instagram.com/fmcet_mdu/?igshid=MzNlNGNkZWQ4Mg%3D%3D"
                        class="d-block"
                        target="_blank"
                      >
                        <i class="bx bxl-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                  <h3 class="footer-widget-title">Site Map</h3>

                  <ul class="support-link">
                    <li><a routerLink="/admission">Admissions</a></li>
                    <li><a routerLink="/IQAC">IQAC</a></li>
                    <li>
                      <a href="assets/pdfs/grc.pdf" target="_blank">Grievances Redressal Committee</a>
                    </li>
                    <li>
                      <a href="assets/pdfs/internal.pdf" target="_blank">Internal Compliance Committee</a>
                    </li>
                    <li><a routerLink="/antiragging">Antiragging</a></li>
                    <li><a routerLink="/scst">SC/ST Committee</a></li>
                    <li><a routerLink="/contact">Contact</a></li>
                  </ul>
                </div>
              </div>

              <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                  <h3 class="footer-widget-title">Mandatory</h3>

                  <ul class="useful-link">
                    <li><a href="assets/img/pdf/AICTE.pdf" target="_blank">AICTE Approvals</a></li>
                    <li>
                      <a href="https://www.aicte-india.org/feedback/index.php" target="_blank">AICTE Feedback</a>
                    </li>
                    <li><a href="assets/pdfs/md.pdf" target="_blank">Mandatory Disclosure</a></li>
                    <li><a href="assets/pdfs/ugc.pdf" target="_blank">UGC Undertaking</a></li>
                    <li><a href="assets/pdfs/frp.pdf" target="_blank">Fees Refund Policy</a></li>
                  </ul>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                  <h3 class="footer-widget-title">e-News Letter</h3>

                  <div class="newsletter-box">
                    <a routerLink="/emagazine" class="newsletter-link">
                      <p class="newsletter-text">To get the latest e-news</p>
                    </a>
                  </div>

                  <h3 class="footer-widget-title mt-4">Useful Links</h3>

                  <ul class="useful-link">
                    <li><a href="https://www.aicte-india.org/" target="_blank">AICTE, New Delhi</a></li>
                    <li><a href="https://annauniv.edu/" target="_blank">Anna University, Chennai</a></li>
                    <li><a href="https://dte.tn.gov.in/" target="_blank">DOTE, Tamil Nadu</a></li>
                    <li><a href="https://upsc.gov.in/" target="_blank">UPSC</a></li>
                    <li><a href="https://onlinecourses.nptel.ac.in/" target="_blank">NPTEL</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="footer-bottom-area">
            <p>
              © Fatima Michael College of Engineering & Technology, Madurai
              <a href="https://fmcet.ac.in" target="_blank">| All rights reserved</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  </section>
</div>

<ngx-scrolltop></ngx-scrolltop>